export default __webpack_public_path__ + "static/media/marked.af2ab573.png";